import axios, { all } from 'axios';
import { API_BASE_URL } from '../ApiConfig';


export const getSecureToken = async () => {
    const res = await axios.get(`${API_BASE_URL}secure/generate-token.php`, {
        withCredentials: true,
    });
    // console.log(res.data)
    const { token: secrettoken, ts } = res.data;
    return { secrettoken, ts };
};

const getAuthHeaders = async () => {
    const { secrettoken, ts } = await getSecureToken();
    return {
        'X-TOKEN': secrettoken,
        'X-TIMESTAMP': ts,
    };
};


///plan check///
export const checkPlanStatus = async () => {
    const headers = await getAuthHeaders();
    try {
        const email = localStorage.getItem("userEmail");
        if (!email) return "error";


        const response = await axios.get(`${API_BASE_URL}payment/check_plan.php`, {
            params: { email },
            headers,
            withCredentials: true,
        });

        const data = response.data;
        return data.status === "active" ? "active" : "expired";
    } catch (error) {
        console.error("Error checking plan status:", error);
        return "error";
    }
};


export const fetch_screener_stocks = async (strategy = "", page = 1) => {
    const headers = await getAuthHeaders();
    try {
        const url = strategy
            ? `${API_BASE_URL}Screener/fetch_screener.php?strategy=${strategy}&page=${page}`
            : `${API_BASE_URL}Screener/fetch_screener.php?page=${page}`;


        const response = await axios.get(url, {
            headers,
            withCredentials: true,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching screener stocks:", error);
        return [];
    }
};
export const fetch_admin_screener_stocks = async (strategy = "", page = 1) => {
    const headers = await getAuthHeaders();
    try {
        const url = strategy
            ? `${API_BASE_URL}Screener/fetch_screener_admin.php?strategy=${strategy}&page=${page}`
            : `${API_BASE_URL}Screener/fetch_screener_admin.php?page=${page}`;


        const response = await axios.get(url, {
            headers,
            withCredentials: true,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching screener stocks:", error);
        return [];
    }
};




export const fetch_live_price = async (scripcode) => {
    try {
        const { secrettoken, ts } = await getSecureToken();

        const response = await axios.get(`${API_BASE_URL}Screener/get_live_price.php`, {
            params: { scripcode },
            headers: {
                'X-TOKEN': secrettoken,
                'X-TIMESTAMP': ts,
            },
            withCredentials: true,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching live price:", error);
        return { live_price: "N/A" };
    }
};


export const fetch_fii_dii_Data = async () => {
    try {
        const headers = await getAuthHeaders();

        const response = await axios.get(`${API_BASE_URL}fundamental/fetch_fii_dii.php`, {
            headers,
            withCredentials: true,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching FII/DII data:", error);
    }
};




// export const searchCompanies = async (query) => {
//     if (!query) return [];

//     try {
//         const response = await axios.get(`${API_BASE_URL}fundamental/search_companymaster.php`);
// console.log(response)
//         let companyList = [];

//         if (response.data) {
//             companyList = response.data;
//         }

//         return companyList.filter(company =>
//             company?.scripname?.toLowerCase().includes(query.toLowerCase()) ||
//             company?.scripcode?.toLowerCase().includes(query.toLowerCase()) ||
//             company?.companyname?.toLowerCase().includes(query.toLowerCase()) ||
//             company?.fincode?.toLowerCase().includes(query.toLowerCase()) ||  
//             company?.symbol?.toLowerCase().includes(query.toLowerCase()) 
//         );
//     } catch (error) {
//         console.error("Search API Error:", error);
//         return [];
//     }
// };

export const searchCompanies = async (query) => {
    if (!query) return [];

    const headers = await getAuthHeaders();
    try {

        const response = await axios.get(
            `${API_BASE_URL}fundamental/search_companymaster.php`,
            {
                params: { query },
                headers,
                withCredentials: true,
            }
        );

        return response.data || [];
    } catch (error) {
        console.error("Search API Error:", error);
        return [];
    }
};





export const getCompany_masterData = async (scripcode) => {
    try {
        const headers = await getAuthHeaders();

        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_companymaster.php?scripcode=${scripcode}`,
            {
                headers,
                withCredentials: true,
            }
        );

        return response.data || null;
    } catch (error) {
        console.error("Error fetching company data:", error);
        return null;
    }
};




export const get_liveprice = async (scripcode) => {
    try {
        const headers = await getAuthHeaders();

        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_liveprice.php?scripcode=${scripcode}`,
            {
                headers,
                withCredentials: true,
            }
        );

        return response.data || null;
    } catch (error) {
        console.error("Error fetching live price:", error);
        return null;
    }
};


export const fetchStock_profitloss = async (fincode) => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_profit_loss.php?fincode=${fincode}`, {
            headers,
            withCredentials: true,
        }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching stock data:", error);
        return null;
    }
};


export const fetchStock_balancesheet = async (fincode) => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_balance_sheet.php?fincode=${fincode}`, {
            headers,
            withCredentials: true,
        }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching stock data:", error);
        return null;
    }
};


export const fetchStock_cashflow = async (fincode) => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_cash_flow.php?fincode=${fincode}`, {
            headers,
            withCredentials: true,
        }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching stock data:", error);
        return null;
    }
};


export const fetch_finance_ratio = async (fincode) => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_finance_ratio.php?fincode=${fincode}`, {
            headers,
            withCredentials: true,
        }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching stock data:", error);
        return null;
    }
};


export const fetch_quick_finance_ratio = async (fincode) => {
    try {
        const headers = await getAuthHeaders();

        const response = await axios.get(
            `${API_BASE_URL}fundamental/quick_analysis_ration.php?fincode=${fincode}`, {
            headers,
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching stock data:", error);
        return null;
    }
};


export const fetch_share_holders_data = async (fincode) => {
    try {
        const headers = await getAuthHeaders();

        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_share_summary.php?fincode=${fincode}`, {
            headers,
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching stock data:", error);
        return null;
    }
};


export const fetchStockData = async (scripcode, months) => {
    try {
         const headers = await getAuthHeaders();

        const response = await axios.get(
            `${API_BASE_URL}fundamental/fetch_adj_price.php?scripcode=${scripcode}&months=${months}`,
            {
                headers,
                withCredentials: true,
            }
        );
        // console.log(response);

        // ✅ Ensure valid response
        if (!response.data || !response.data.data || !Array.isArray(response.data.data)) {
            console.warn("Unexpected API response format:", response.data);
            return [];
        }

        let allData = response.data.data.map((item) => ({
            ...item,
            Close: parseFloat(item.Close) || 0,
            Open: parseFloat(item.Open) || 0,
            High: parseFloat(item.high) || 0,
            Low: parseFloat(item.low) || 0,
            Value: parseFloat(item.Value) || 0,
            Volume: parseFloat(item.Volume) || 0,
            Date: item.Date || 0,
            // Year: parseInt(item.Year, 10),
            // Month: parseInt(item.Month, 10),
        }));

        // console.log(allData);

        // // ✅ Sort data in descending order (latest first)
        // allData.sort((a, b) => new Date(b.Year, b.Month - 1) - new Date(a.Year, a.Month - 1));

        // // ✅ Take the latest `N` months from sorted data
        // allData = allData.slice(0, months);

        // // ✅ Sort again in ascending order for the chart (oldest first)
        // allData.sort((a, b) => new Date(a.Year, a.Month - 1) - new Date(b.Year, b.Month - 1));
        // console.log(allData);

        return allData;
    } catch (error) {
        console.error("Error fetching stock data:", error);
        return [];
    }
};




///////////NEWS////////////////////////

export const fetchNews_company_news = async (secname = '', subsecname = '') => {
    try {
        const headers = await getAuthHeaders();

        const response = await axios.get(`${API_BASE_URL}news/fetch_company_news.php`, {
            params: {
                secname,
                subsecname
            },
            headers,
            withCredentials: true,
        });

        return response.data;
    } catch (error) {
        console.error("❌ fetchNews_company_news error:", error);
        return [];
    }
};
